import { tvpil } from '../compat/tvpil';

export function useDms() {
  return tvpil.dms;
}
